import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import AppointmentCalender from './appointmentCalender';
import { setMainHeading } from '../../../redux/modules/mainHeading/slice';
import RadiologyForm from '../radiology/form';
import { setShowList } from '../../../redux/modules/showList/slice';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Typography, Stack } from '@mui/material';
import ScienceOutlinedIcon from '@mui/icons-material/ScienceOutlined';
import moment from 'moment';

export default function Appointment() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { currentBranch } = useSelector(state => state.branch);
    const { showList } = useSelector(state => state.reduxShowList);
    const hospitalModules = useSelector(state => state.hospitalConfig?.modules);
    const risOn = !!(hospitalModules?.ris?.enabled ?? hospitalModules?.ris);
    const lisOn = !!(hospitalModules?.lis?.enabled ?? hospitalModules?.lis);
    const [appoinmentDate, setAppoinmentDate] = useState(null);
    const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);

    const toggleList = () => {
        dispatch(setShowList(!showList));
    };

    const handleConfirmDialogClose = (confirmed) => {
        setShowConfirmationDialog(false);
        if (confirmed) {
            dispatch(setShowList(false));
        }
    };

    useEffect(() => {
        if (!currentBranch) {
            return;
        }
        dispatch(setShowList(true));
    }, [dispatch, currentBranch]);

    useEffect(() => {
        dispatch(setMainHeading('Appointment Scheduling'));
    }, [dispatch]);

    useEffect(() => {
        if (appoinmentDate) {
            const currentDate = moment().startOf('day');
            const selectedDate = moment(appoinmentDate).startOf('day');
            // Allow same day appointments - only block strictly past dates
            if (selectedDate.isBefore(currentDate)) {
                setShowConfirmationDialog(true);
            } else {
                dispatch(setShowList(false));
            }
        }
    }, [appoinmentDate, dispatch]);


    const basePath = location.pathname.split('/appointment')[0];
    const renderFollowUp = () => {
        if (risOn) {
            return <RadiologyForm toggleList={toggleList} appoinmentDate={appoinmentDate} />;
        }
        if (lisOn) {
            return (
                <Box sx={{ p: 4, textAlign: 'center' }}>
                    <Stack spacing={2} alignItems="center">
                        <ScienceOutlinedIcon sx={{ fontSize: 56, color: 'primary.main' }} />
                        <Typography variant="h5">
                            {appoinmentDate ? moment(appoinmentDate).format('dddd, MMMM D, YYYY') : 'Lab visit'}
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 480 }}>
                            Appointments for this hospital are tracked as lab orders. Create one for the
                            selected date below.
                        </Typography>
                        <Stack direction="row" spacing={2}>
                            <Button variant="outlined" onClick={toggleList}>Back to calendar</Button>
                            <Button
                                variant="contained"
                                onClick={() => {
                                    const dateParam = appoinmentDate ? `?appointmentDate=${encodeURIComponent(moment(appoinmentDate).format('YYYY-MM-DD'))}` : '';
                                    navigate(`${basePath}/laboratory/orders/new${dateParam}`);
                                }}
                            >
                                Create lab order
                            </Button>
                        </Stack>
                    </Stack>
                </Box>
            );
        }
        return (
            <Box sx={{ p: 4, textAlign: 'center' }}>
                <Typography variant="body1" color="text.secondary">
                    No clinical modules enabled. Appointments are read-only.
                </Typography>
                <Button variant="outlined" sx={{ mt: 2 }} onClick={toggleList}>Back to calendar</Button>
            </Box>
        );
    };

    return (
        <>
            {showList ? (
                <AppointmentCalender toggleList={toggleList} setAppoinmentDate={setAppoinmentDate} />
            ) : (
                renderFollowUp()
            )}

            <Dialog open={showConfirmationDialog} onClose={() => handleConfirmDialogClose(false)}>
                <DialogTitle>Confirmation</DialogTitle>
                <DialogContent>
                    You are trying to create an appointment for a past date. Please select a valid future date.
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => handleConfirmDialogClose(false)} color="primary">
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

